import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styles from './default-field-layout.scss';
import { useFieldView, useFormView } from '../contexts/form-view-context';
import { isInputField } from '../ui/form/types';
import { useExperiments } from '../contexts/experiments-context';
import { EXPERIMENTS } from '../constants';
import classNames from 'classnames';
import { classes } from './default-field-layout.st.css';
export const DefaultFieldLayout = _ref => {
  let {
    fieldId,
    ...rest
  } = _ref;
  const formView = useFormView();
  const experiments = useExperiments();
  const fieldView = useFieldView(fieldId);
  if (!fieldView) {
    return null;
  }
  const isInLastRow = getLastRow(formView) === fieldView.layout.row;
  const isRemoveFlexboxEnabled = experiments.isExperimentEnabled(EXPERIMENTS.REMOVE_FLEXBOX);
  const useCSSVars = experiments.isExperimentEnabled(EXPERIMENTS.USE_CSS_VARS_ONLY);
  const verticalGap = isRemoveFlexboxEnabled ? /*#__PURE__*/React.createElement("div", {
    style: useCSSVars ? undefined : {
      height: isInLastRow ? 0 : `${formView.grid.margin.vertical}px`
    },
    className: classNames({
      [classes.verticalGap]: useCSSVars && !isInLastRow
    })
  }) : null;
  const {
    layout,
    fieldType
  } = fieldView;
  const dataHook = `form-field-${isInputField(fieldView) ? fieldView.target : fieldView.id}`;
  const dataAttributes = {
    'data-hook': dataHook,
    'data-field-type': fieldType
  };
  const rows = [1, 2];
  let gridRow = `1 / span ${rows.length}`;
  let gridColumn = `${layout.column + 1} / span ${layout.width}`;
  let [labelRow, inputRow] = rows.map(currentRow => `${currentRow} / span 1`);
  if (isRemoveFlexboxEnabled) {
    gridRow = `${layout.row * rows.length + 1} / span ${rows.length}`;
    gridColumn = `${layout.column + 1} / span ${layout.width}`;
    [labelRow, inputRow] = rows.map(currentRow => `${layout.row * rows.length + currentRow} / span 1`);
  }
  if ('children' in rest) {
    return /*#__PURE__*/React.createElement("div", _extends({
      style: {
        gridRow,
        gridColumn
      }
    }, dataAttributes), rest.children, verticalGap);
  }
  const {
    renderLabel,
    renderInput,
    renderDescription
  } = rest;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      gridRow: labelRow,
      gridColumn
    },
    className: styles.label
  }, renderLabel()), /*#__PURE__*/React.createElement("div", _extends({
    style: {
      gridRow: inputRow,
      gridColumn
    }
  }, dataAttributes), renderInput(), renderDescription(), verticalGap));
};
function getLastRow(form) {
  return form.fields.reduce((result, field) => {
    const currentRow = field.layout.row;
    return currentRow > result ? currentRow : result;
  }, 0);
}
//# sourceMappingURL=default-field-layout.js.map